import { getEffectiveDateTime } from "../../constants/common-constants";
import { IAddUpdateFotaMzlConfig } from "../../models/response/IFotaNewResponse";

export const addEditFotaMzlConfigInitialState: IAddUpdateFotaMzlConfig = {
  EffectiveDateTimestamp:getEffectiveDateTime(),
  ConfigName: "",
  Version: "",
  File: "",
  FileContent: "",
  FileType:0,
  Description: "",
  FileName: "",
  WantToUpdateFile:"false",
};